import { PATH_NAME } from 'configs';
import React, { useState } from 'react';
import { useHistory } from 'react-router';
import DynamicTable from 'utils/DynamicTable';
import { LatestUpdateTableHeaders } from 'utils/TableHeaderUtils';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import AddIcon from '@material-ui/icons/Add';

export const modifiedLatestUpdateData = [
  {
    _id: '6',
    title: 'Access- The Photo-Digest',
    description: 'This volume consists of best practices in the Built Infrastructure from all over India.',
    date: '15-Feb-2021',
  },
  {
    _id: '3',
    title: 'Rights of Persons with Disabilities Act 2016',
    description:
      'The RPWD Act, 2016 provides that “the appropriate Government shall ensure that the PWD enjoy the right to equality, life with dignity, and respect for his or her own integrity equally with others.” The Government is to take steps to utilize the capacity of the PWD by providing appropriate environment.',
    date: '12-Feb-2021',
  },
  {
    _id: '9',
    title: 'Rights of Persons with Disabilities Act 2016 (in Hindi)',
    description: 'Rights of Persons with Disabilities Act 2016 (in Hindi)',
    date: '12-Mar-2021',
  },
  {
    _id: '4',
    title: 'Rights of Persons with Disabilities Rules 2017',
    description:
      'The RPwD Rules, 2017 were drafted to ensure that the Persons with Disabilities enjoy the right to equality, life with dignity, and respect for his or her own integrity equally with others.',
    date: '15-Feb-2021',
  },
  {
    _id: '10',
    title: 'Rights of Persons with Disabilities Rules 2017 (in Hindi)',
    description: 'Rights of Persons with Disabilities Rules 2017 (in Hindi)',
    date: '12-Mar-2021',
  },
];

const LatestUpdateList = () => {
  const [data, setData] = useState([]);
  const history = useHistory();
  const [currentPage, setCurrentPage] = useState(1);
  const totalComplaints = 10;

  const handleEdit = (id: string) => {
    // Handle edit action
    history.push(`${PATH_NAME.LATEST_UPDATE_EDIT}/${id}`);

    console.log('Edit:', id);
  };

  const handleDelete = (id: string) => {
    // Handle delete action
    console.log('Delete:', id);
  };

  return (
    <div>
      <Grid container style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h1>Latest Updates</h1>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          onClick={() => history.push(PATH_NAME.LATEST_UPDATE_ADD)}
        >
          Add New
        </Button>
      </Grid>

      <DynamicTable
        headers={LatestUpdateTableHeaders}
        rows={modifiedLatestUpdateData}
        onEdit={handleEdit}
        onDelete={handleDelete}
        setCurrentPage={setCurrentPage}
        noOfPages={totalComplaints}
      />
    </div>
  );
};

export default LatestUpdateList;
